<template>
    <div class="content-container">
        <div class="content">
            <div class="container">
                <div class="row">

                    <!-- Title -->
                    <div class="col-12">
                        <div class="title">
                            <h1>{{ pageTitle }}</h1>
                        </div>
                    </div>

                    <!-- Options -->
                    <div class="col-12">
                        <div class="card-list scrollable" v-if="models.length > 0">
                            <div class="selectable-card"
                                 v-for="model in models"
                                 :key="model.id"
                                 @click="selectModel(model)"
                                 :class="{ active: modelIsActive(model) }">
                                <div class="card-body">
                                    <p>
                                        {{ model.title }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- Empty state -->
                        <empty-state
                            v-if="models.length === 0"
                            icon="device-invalid"
                            title="Sorry, we don't currently repair that type of device"
                            subtitle="Hit the back button to select a different device type"
                        ></empty-state>

                    </div>
                </div>
            </div>

            <!-- Footer -->
            <footer class="footer fixed-footer">
                <div class="container">
                    <router-link :to="{ name: 'deviceType'}" class="btn btn-outline-secondary back-btn btn-lg"><i class="fa fa-chevron-left text-sm mr-3"></i> Back</router-link>
                    <router-link :to="{ name: 'deviceColour'}" class="btn btn-lg continue-btn icon-right ml-auto" :class="{'disabled': !modelHasBeenSelected}">Next <i class="fa fa-chevron-right ml-3 text-sm"></i></router-link>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "DeviceModel",

        mounted() {
            this.checkCanBeOnPage();
        },

        computed: {
            ...mapGetters(['isBookingInStore', 'models', 'modelHasBeenSelected', 'modelIsActive', 'typeHasBeenSelected']),

            pageTitle() {
                if (this.isBookingInStore) {
                    return "What model is it?";
                }

                return "What model do you have?";
            }
        },

        methods: {
            ...mapActions(['checkBookingIsComplete', 'selectModel']),

            checkCanBeOnPage() {
                this.checkBookingIsComplete().then(() => {
                    if (!this.typeHasBeenSelected) {
                        this.$router.push({name: 'deviceType'});
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>